/** Dedupe vitrine sibling tabs (прямой + pryamoy → one card). */

const SLUG_CANON: Record<string, string> = {
  pryamoy: 'pryamoy',
  pryamoi: 'pryamoy',
  'прямой': 'pryamoy',
  radialniy: 'radialniy',
  'радиальный': 'radialniy',
  lyuversy: 'lyuversy',
  'люверсы': 'lyuversy',
  'для люверсов': 'lyuversy',
  naklonniy: 'naklonniy',
  'наклонный': 'naklonniy',
  scenicheskiy: 'scenicheskiy',
  'сценический': 'scenicheskiy',
  uglovoy: 'uglovoy',
  'угловой': 'uglovoy',
};

export type SiblingLike = {
  group_id: string;
  name: string;
  variants_count?: number;
};

function canonKey(g: SiblingLike): string {
  const gid = g.group_id || '';
  if (gid.includes('::')) {
    const slug = gid.split('::')[1]?.trim().toLowerCase() || '';
    return SLUG_CANON[slug] || slug;
  }
  const name = g.name.trim().toLowerCase();
  return SLUG_CANON[name] || name;
}

function score(g: SiblingLike): number {
  let s = 0;
  if (g.group_id.includes('::')) s += 200;
  if (g.group_id.includes('pryamoy')) s += 40;
  s += Number(g.variants_count ?? 0) * 2;
  if (!g.group_id.startsWith('v2::')) s += 30;
  return s;
}

export function dedupeSiblingGroups<T extends SiblingLike>(rows: T[]): T[] {
  const best = new Map<string, T>();
  for (const row of rows) {
    const key = canonKey(row);
    const prev = best.get(key);
    if (!prev || score(row) > score(prev)) best.set(key, row);
  }
  return [...best.values()];
}
